import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The Bean",
    body: "We buy small lots from farms we've stood on. Every green bag arrives with a name, an altitude, and a story we can repeat.",
  },
  {
    n: "02",
    title: "The Roast",
    body: "Roasted the same week you drink it. No hiding behind darkness — we chase clarity, not char.",
  },
  {
    n: "03",
    title: "The Pour",
    body: "18 seconds of bloom. 2:20 total. A pour-over is a conversation between water, gravity, and the person holding the kettle.",
  },
  {
    n: "04",
    title: "The Room",
    body: "Cast iron, warm oak, and a stubborn absence of Wi-Fi passwords. This is a room built for slowing down.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40 border-t border-bone/10 bg-ink-soft"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
          className="grid grid-cols-12 gap-4 md:gap-8 mb-16 md:mb-24"
        >
          <div className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-widest-2 text-bone/50">
            <div className="w-8 h-px bg-bone/40 mb-3" />
            The Manifesto
          </div>
          <h2 className="col-span-12 md:col-span-9 font-serif font-light text-4xl md:text-[5.5vw] leading-[0.9] tracking-tightest text-bone">
            Four things we <span className="italic text-gold">refuse</span> to hurry.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-x-6 md:gap-x-12 gap-y-14 md:gap-y-24">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 1, delay: (i % 2) * 0.1, ease: [0.19, 1, 0.22, 1] }}
              className={`col-span-12 md:col-span-6 ${i % 2 === 1 ? "md:pt-24" : ""}`}
            >
              <div className="flex items-start gap-6 md:gap-10">
                <span className="font-serif text-6xl md:text-8xl text-bone/15 leading-none flex-shrink-0">
                  {c.n}
                </span>
                <div className="pt-2 md:pt-3">
                  <h3 className="font-serif text-3xl md:text-5xl text-bone mb-4 md:mb-6 tracking-tightest">
                    <span className="italic">{c.title.split(" ")[0]}</span>{" "}
                    {c.title.split(" ").slice(1).join(" ")}
                  </h3>
                  <p className="text-sm md:text-base text-bone/60 font-light leading-relaxed max-w-md">
                    {c.body}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
